import valorantAvatar from "@assets/avatars/valorant-avatar.png";
import AvatarWithText from "@core-components/avatar-text/AvatarWithText";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import SSHeadLineHeader from "@core-components/title/components/SSHeadLineHeader";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Text } from "@mantine/core";
import { Trans } from "react-i18next";
import ValorantBackgroundImage from "../components/ValorantBackgroundImage";
import ValorantGradientText from "../components/ValorantGradientText";

const ValorantHeroBanner = () => {
  const { t } = useAppTranslation("pages.valorant.hero");
  return (
    <ValorantBackgroundImage>
      <SSBgImageHeadline
        props={{
          stack: {
            className: "py-14 xs:py-[150px] !pb-0",
          },
        }}
        header={<SSHeadLineHeader>{t("bannerHeader")}</SSHeadLineHeader>}
        subTitle={
          <AvatarWithText
            className="w-full"
            avatars={[valorantAvatar]}
            text={
              <Trans
                t={t}
                i18nKey="bannerText"
                components={[
                  <Text inherit span fw="bold" key="0" />,
                  <Text inherit span fw="bold" key="1" />,
                ]}
              />
            }
          />
        }
      >
        <SSWhiteText>{t("title")}</SSWhiteText>
        <br />
        <ValorantGradientText>{t("game")}</ValorantGradientText>
      </SSBgImageHeadline>
    </ValorantBackgroundImage>
  );
};

export default ValorantHeroBanner;
